<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" fullscreen persistent>
      <v-card class="risk-assessment scroll-form" height="100%">
        <v-card-title
          class="headline indigo darken-4 white--text fixed-header"
          primary-title
        >
          {{
            $vuetify.t('$vuetify.powra.pointOfWorkRiskAssessment').toUpperCase()
          }}
        </v-card-title>
        <v-layout row wrap>
          <PowraTitle
            :avatar="'E'"
            :title="
              $vuetify.t('$vuetify.powra.controlMeasuresSafetyPrecautions')
            "
          />

          <v-flex xs12 px-3 class="font-weight-bold">
            {{ $vuetify.t('$vuetify.app.yes') }}
            <span class="ml-1">{{
              $vuetify.t('$vuetify.powra.controlMeasuresPrecautions')
            }}</span>
          </v-flex>

          <v-flex
            xs12
            px-3
            v-for="(control, i) in powraData.controls"
            :key="control.code"
            :class="i % 2 == 0 ? '' : 'blue-grey lighten-5'"
          >
            <v-checkbox
              v-model="selectedControls[control.code]"
              :value="control"
              class="py-0"
              color="green"
              @change="updateControls($event)"
            >
              <div slot="label">
                {{ control.name }}
              </div>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <powra-f
          v-on:newControl="addControl(...arguments)"
          v-on:adequateControlsToHazards="
            updatePowraFAdequateControlsToHazards(...arguments)
          "
          :controls="controls"
        >
        </powra-f>

        <div class="footer text-xs-center mb-3">
          <v-divider></v-divider>
          <v-card-text>
            <v-btn @click="back()">
              {{ $vuetify.t('$vuetify.calls.back') }}
            </v-btn>

            <v-btn color="success" @click="confirm()">
              {{ $vuetify.t('$vuetify.calls.proceedToTheNextSection') }}
            </v-btn>
            <abort-visit v-on:aborted="visitAborted(...arguments)" />
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorDialog" width="500">
      <v-card>
        <v-card-title class="headline red white--text" primary-title>
          {{ $vuetify.t('$vuetify.powra.checkSafetyPrecautions') }}
        </v-card-title>
        <v-card-text>
          <v-container pa-1>
            <v-layout row>
              <v-flex shrink>
                <v-icon color="red" x-large>warning</v-icon>
              </v-flex>
              <v-flex pl-3>
                {{
                  $vuetify.t('$vuetify.powra.selectAtLeastOneControlMeasure')
                }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="errorDialog = false">
            {{ $vuetify.t('$vuetify.app.ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AbortVisit from '@/components/AbortVisit.vue'
import PowraF from '@/components/powra/PowraF.vue'
import PowraTitle from '@/components/powra/PowraTitle.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import powraData from '../../data/forms/powra.json'

export default {
  props: ['show', 'controls'],
  components: {
    AbortVisit,
    PowraF,
    PowraTitle
  },
  data() {
    return {
      dialog: false,
      powraFAdequateControlsToHazards: false,
      errorDialog: false,
      powraData,
      selectedControls: [],
      other_controls: null
    }
  },
  computed: {
    ...mapState({
      // currentRiskAssessment: state => state.calls.currentRiskAssessment,
    }),
    ...mapGetters({
      getActiveCall: 'calls/getActiveCall',
      hasPowra: 'calls/hasPowra',
      currentRiskAssessment: 'calls/currentRiskAssessment'
    }),
    callDetail() {
      return this.getActiveCall
    }
  },
  methods: {
    ...mapActions({
      saveRiskAssessmentControls: 'calls/saveRiskAssessmentControls'
    }),

    addControl(control) {
      this.selectedControls.other_controls = {
        code: 'other_controls',
        name: control
      }
      this.updateControls('other_controls')
    },

    updatePowraFAdequateControlsToHazards(value) {
      this.powraFAdequateControlsToHazards = value
    },
    confirm() {
      if (Object.keys(this.selectedControls).length === 0) {
        this.errorDialog = true
      } else {
        //console.log(this.other_controls)
        //this.selectedControls['other_controls'] = this.other_controls.value.length > 0 ? this.other_controls : null
        this.dialog = false
        this.$emit('confirmed', {
          controls: this.selectedControls,
          powraFAdequateControlsToHazards: this.powraFAdequateControlsToHazards
        })
      }
    },
    visitAborted() {
      this.dialog = false
      this.$emit('aborted')
    },
    back() {
      this.dialog = false
      this.$emit('back')
    },
    populateActivePowraValues() {
      _.each(this.powraData.controls, control => {
        if (this.currentRiskAssessment.fields.controls[control.code]) {
          this.selectedControls[control.code] = control
        }
      })
    },
    updateControls(value) {
      this.saveRiskAssessmentControls(this.selectedControls)
    }
  },
  watch: {
    show: function(newVal, oldVal) {
      this.dialog = newVal
    },
    hasPowra: function() {
      if (this.hasPowra) {
        this.populateActivePowraValues()
      }
    }
  }
}
</script>

<style scoped>
.footer {
  position: -webkit-sticky;
  position: sticky;
  background-color: #ffffff;
  bottom: 0;
  width: 100%;
  height: 100px;
}
.fixed-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 300;
}
.scroll-form {
  height: 100%;
  position: relative;
  overflow-y: scroll;
}
</style>
